export default __webpack_public_path__ + "static/AppQr-5255f9ff7ed876d3685022a24aa0251a.svg";